import React from 'react';
import CanonicalResellerMerchantManagementComponent from './canonical-reseller-merchant-management.component';

function CanonicalResellerMerchantManagement(props) {
    return <CanonicalResellerMerchantManagementComponent {...props} />;
}

export default CanonicalResellerMerchantManagement;
